
import { IUpdateUserPasswordParam, IUpdateUserPhoneParam } from '../../types/user-center/personal';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 个人中心用户基本信息 - 修改姓名
 */
export async function editUserName(name: string) {
  try {
    const { code, message } = await Http.put<void>(`${hostUrl}/iam/user/updateName`, { name });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 个人中心用户基本信息 - 修改密码
 */
export async function updateUserPassword(params: IUpdateUserPasswordParam) {
  const hasCode = !!params.code;
  const url = hasCode ? '/sms/updatePwd' : '/updatePwd';

  try {
    const { code, message } = await Http.put<void>(`${hostUrl}/iam/user${url}`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 个人中心用户基本信息 - 修改手机号
 */
export async function updateUserPhone(params: IUpdateUserPhoneParam) {
  try {
    const { code, message } = await Http.put<void>(`${hostUrl}/iam/user/updatePhone`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}
